import Vue from 'vue'
import App from './App.vue'


// 引入ELEMENT
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

import './assets/iconfont/iconfont.css'

import './assets/common.css'

// 引入FILTER
import filters from '../src/utils/filter'
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})

// 引入全局配置
import config from '../src/utils/config'
Vue.prototype.$config = config.data

// 全局广告组件
import AdvertBanner from "./components/advertBanner";
Vue.component('AdvertBanner', AdvertBanner)

// 全局广告组件
import advertCarousel from "./components/advertCarousel";
Vue.component('advertCarousel', advertCarousel)

// 全局广告组件
import AdvertGroup from "./components/advertGroup";
Vue.component('AdvertGroup', AdvertGroup)

// 动态标题
import Meta from 'vue-meta'
Vue.use(Meta)

Vue.config.productionTip = false

import router from './router'
import store from './store'
router.beforeEach((to, from, next) => {
	document.title = (to.meta.title ? to.meta.title + '-' : '') + '万帮广告'
	next()
})

// 全局加载广告
import {
	httpRequest
} from '@/utils/app'
httpRequest({
	action: 'advert_cates'
}).then(response => {
	Vue.prototype.$advs = response.data

	// 广告数据加载完成后创建应用
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')
})